export default function () {
    return function (value) {
        return (!value) ? '' : value.replace(/ /g, '');
    };
};



/** WEBPACK FOOTER **
 ** ./js/filters/nospace.js
 **/